import { createContext, useContext } from "react";
import PropTypes from "prop-types";

// Shared asset/bot components render under more than one builder, so the
// read-only flag travels by context instead of ten layers of prop drilling.
// Defaults to false so the same components stay interactive when they are
// rendered outside a builder (Explore, Research).
export const BuilderReadOnlyContext = createContext(false);

export const BuilderReadOnlyProvider = ({ readOnly = false, children }) => {
  return (
    <BuilderReadOnlyContext.Provider value={readOnly}>
      {children}
    </BuilderReadOnlyContext.Provider>
  );
};

BuilderReadOnlyProvider.propTypes = {
  readOnly: PropTypes.bool,
  children: PropTypes.node,
};

export const useBuilderReadOnly = () => useContext(BuilderReadOnlyContext);
